import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useEffect, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import styles from "./styles.module.scss";
const QuestionHeader = (props) => {
    const ref = useRef(null);
    useEffect(() => {
        props.setRef(ref);
    }, []);
    const { isHyrox } = props;
    return (_jsxs("div", { className: styles.quiz_question, children: [props.header && (_jsx("div", { className: styles.main_question, children: _jsx(CSSTransition, { in: props.show, timeout: isHyrox ? 0 : 200, classNames: isHyrox
                        ? { enterDone: styles.MyClassEnterDone }
                        : {
                            enterActive: styles.MyClassEnterActive,
                            enterDone: styles.MyClassEnterDone,
                            exitActive: styles.MyClassExit,
                            exitDone: styles.MyClassExitActive,
                        }, children: _jsx("h5", { children: props.header }) }) })), props.subheader && _jsx("p", { className: styles.question_subheader, children: "subheader" }), props.whytext && (_jsxs("div", { className: styles.why_container, children: [_jsx(CSSTransition, { in: props.show, timeout: isHyrox ? 0 : 200, classNames: isHyrox
                            ? { enterDone: styles.WhyAskEnterDone }
                            : {
                                enterActive: styles.WhyAskEnterActive,
                                enterDone: styles.WhyAskEnterDone,
                                exitActive: styles.WhyAskExit,
                                exitDone: styles.WhyAskExitActive,
                            }, children: _jsx("button", { type: "button", ref: ref, className: styles.why_popup, onClick: () => props.isOpen(true), onKeyDown: () => props.isOpen(true), children: props.whytext && props.whytitle ? props.whytitle.toUpperCase() : null }) }), _jsx(CSSTransition, { in: props.show, timeout: isHyrox ? 0 : 200, classNames: isHyrox
                            ? { enterDone: styles.WhyUnderlineEnterDone }
                            : {
                                enterActive: styles.WhyUnderlineEnterActive,
                                enterDone: styles.WhyUnderlineEnterDone,
                                exitActive: styles.WhyUnderlineExit,
                                exitDone: styles.WhyUnderlineExitActive,
                            }, children: _jsx("div", { className: styles.why_underline }) })] }))] }));
};
export default memo(QuestionHeader);
QuestionHeader.defaultProps = {
    whytext: "",
    whytitle: "",
    subheader: "",
};
